import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';

type MasterLabelLinkProps = Omit<LinkProps, 'target' | 'rel'> & {
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
  variant?: 'default' | 'forge';
};

export const MasterLabelLink: React.FC<MasterLabelLinkProps> = ({
  target = '_blank',
  rel = 'noopener noreferrer',
  variant = 'default',
  className,
  ...props
}) => {
  const classes = [variant === 'forge' ? 'forge-master-label-link' : null, className]
    .filter(Boolean)
    .join(' ');
  return <Link {...props} className={classes || undefined} target={target} rel={rel} />;
};
